import styled from 'styled-components';
import Tooltip from '../../CommonComponents/Tooltip';

export const StyledTooltip = styled(Tooltip)`
  font-size: 14px;
  color: #9c9c9c;
  margin-left: 12px;

  &:hover {
    color: #444;
  }
`;
